// extracted by mini-css-extract-plugin
module.exports = {"svgContainer":"SvgPieChart_svgContainer__2JPqe"};